'use client'

import Image from 'next/image'
import logo from '@/app/assets/logo-reassurez-moi.png'
import { LOAN_PHONE_NUMBER, LOAN_PHONE_LINK, LOAN_OPENING_HOURS } from '@/app/constants/contact'
import { AeTrackingEvents } from '@/app/constants/loanAeTracking'
import { useTracking } from '@/app/contexts/tracking-context'
import { useLoanComparatorStore } from '@/app/stores/loan/loan-comparator.store'
import { buildAeParams } from '@/app/utils/loan/loan-ae-tracking'
import dynamic from 'next/dynamic'

const AppIcon = dynamic(() => import('@/app/components/atomic/AppIcon'), {
    ssr: false,
})

export default function LoanComparatorHeader() {
    const { track } = useTracking()
    const quote = useLoanComparatorStore((state) => state.quote)
    const trackClickCall = () => track({ event: AeTrackingEvents.clickCall, ...buildAeParams(quote) })

    return (
        <header className="flex items-center justify-between px-4 md:px-8 py-3 bg-white !container mx-auto">
            {/* Left section - Tagline (desktop only) */}
            <span className="text-blue-700 hidden md:flex items-center text-base font-normal">
                Le n°1 des courtiers en ligne
            </span>

            {/* Center section - Logo (not clickable) */}
            <div className="flex items-center justify-center flex-1 md:flex-none">
                <div className="w-[150px] md:w-[170px]">
                    <Image
                        src={logo}
                        alt="Réassurez-moi"
                        width={170}
                        priority
                    />
                </div>
            </div>

            {/* Right section - Phone and call button */}
            <div className="flex gap-2 items-center">
                {/* Phone number and hours (desktop only) */}
                <div className="hidden md:flex flex-col my-auto text-right">
                    <a
                        href={LOAN_PHONE_LINK}
                        onClick={trackClickCall}
                        className="flex place-self-end whitespace-nowrap text-lg md:text-sm font-bold text-green-900 no-underline"
                    >
                        {LOAN_PHONE_NUMBER}
                    </a>
                    <span className="text-sm">
                        {LOAN_OPENING_HOURS}
                    </span>
                </div>

                {/* Call button */}
                <a href={LOAN_PHONE_LINK} aria-label="Appelez-nous gratuitement" onClick={trackClickCall}>
                    <div
                        className="rounded
                            w-[30px] h-[30px] md:w-[50px] md:h-[50px]
                            flex flex-col justify-center items-center gap-1
                            font-bold bg-green-100 p-3 text-green-900 hover:bg-green-200 text-xs"
                    >
                        <AppIcon iconClassName="fa-phone" size="xs" type="regular" className="text-xs" />
                        <p className="hidden md:block mb-0 text-xs">Gratuit</p>
                    </div>
                </a>
            </div>
        </header>
    )
}
